/* TPW hero live chips — open-now status + same-day dispatch countdown.
   All hours / cut-off / public-holiday maths now come from the shared engine
   window.TPWStoreHours (assets/tpw-store-hours.js) — the single source of truth.
   This file only renders chips; it derives no dates of its own. */
(function () {
  'use strict';
  if (window.__tpwHeroChips) return;
  window.__tpwHeroChips = true;

  function SH() { return window.TPWStoreHours; }

  function isOpen() { var s = SH(); return s ? s.isOpen() : false; }

  // { kind:'today', secs } | { kind:'tomorrow'|'future', wd } | null
  function dispatch() {
    var s = SH(); if (!s) return null;
    var d = s.dispatchETA();
    if (d.sameDay) return { kind: 'today', secs: d.secondsToCutoff };
    return { kind: d.relative === 'tomorrow' ? 'tomorrow' : 'future', wd: d.shipParts.wd };
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function init(root) {
    var openLabel = root.querySelector('[data-open-label]');
    var shipLabel = root.querySelector('[data-ship-label]');
    var shipCd = root.querySelector('[data-ship-cd]');

    function tick() {
      // PERF-07: skip all DOM work in a backgrounded tab (matches tpw-bar.js).
      // The chip is re-rendered on the next visible tick, so nothing is lost.
      if (document.hidden) return;
      var open = isOpen();
      root.querySelectorAll('[data-open-dot]').forEach(function (d) {
        d.classList.toggle('is-open', open);
      });
      if (openLabel) openLabel.textContent = open ? 'Open now' : 'Opens 11am';

      var d = dispatch();
      if (!shipLabel || !shipCd) return;
      if (d && d.kind === 'today') {
        var h = Math.floor(d.secs / 3600), m = Math.floor(d.secs % 3600 / 60);
        shipLabel.textContent = 'Ships today';
        // h:mm remaining before the 2pm cutoff (DM Mono digits, dim middot)
        shipCd.textContent = '· ' + h + ':' + pad(m);
        shipCd.hidden = false;
      } else {
        shipLabel.textContent = d && d.kind === 'tomorrow' ? 'Ships tomorrow' : (d ? 'Ships ' + d.wd : 'Ships tomorrow');
        shipCd.hidden = true;
      }
    }

    tick();
    setInterval(tick, 1000);
  }

  function boot() {
    document.querySelectorAll('[data-tpw-hero-chips]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
